module.exports = __webpack_public_path__ + "static/media/Materikin.50a6a089.png";